export enum LeadIcon {
  Fire = "fire",
  Star = "star",
  Bolt = "bolt",
  Flag = "flag",
  Heart = "heart",
  Crown = "crown",
  Gem = "gem",
  Bell = "bell",
  CircleExclamation = "circle_exclamation",
  Thumbtack = "thumbtack",
}
